import { useIntl } from 'react-intl';

import { DownloadableCert } from '../DownloadableCert';

import { ReactComponent as Year140 } from '@/assets/icons/year-140-cert.svg';

import * as M from '../../messages';

export interface DownloadProps {
  channel: string;
  sn: string;
}
export const DownloadableYear140 = ({ channel, sn }: DownloadProps) => {
  const { formatMessage } = useIntl();
  return (
    <DownloadableCert
      Svg={Year140}
      channel={channel}
      data-test-id='DownloadableYear140'
      fileName='140yr'
      sn={sn}
      text={formatMessage(M.messages.year140Certifiacte)}
    />
  );
};

DownloadableYear140.displayName = 'DownloadableYear140';
